export const CyDelayedFilterInput = {
  InputBoxSearchSong: "InputBoxSearchSong",
} as const;
